import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Checkbox from '@material-ui/core/Checkbox';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import PropTypes from 'prop-types';
import React from 'react';

const DedicatedLoadHeadCells = [
  //   {
  //     id: 'source',
  //     numeric: false,
  //     disablePadding: false,
  //     label: 'Source',
  //   },
  { id: 'origin.name', numeric: false, disablePadding: false, label: 'Origin' },
  {
    id: 'pickup_location',
    numeric: false,
    disablePadding: false,
    label: 'P/U Location',
  },
  {
    id: 'pick_up_date',
    numeric: false,
    disablePadding: false,
    label: 'P/U Date',
  },
  {
    id: 'pick_up_time_start',
    numeric: false,
    disablePadding: false,
    label: 'P/U Time',
  },
  {
    id: 'dh_o',
    numeric: false,
    disablePadding: false,
    label: 'DH-O',
  },
  {
    id: 'destination.name',
    numeric: false,
    disablePadding: false,
    label: 'Destination',
  },
  {
    id: 'drop_off_location',
    numeric: false,
    disablePadding: false,
    label: 'D/O Location',
  },
  {
    id: 'drop_off_date',
    numeric: false,
    disablePadding: false,
    label: 'D/O Date',
  },
  {
    id: 'delivery_date_time',
    numeric: false,
    disablePadding: false,
    label: 'D/O Time',
  },
  {
    id: 'dh_d',
    numeric: false,
    disablePadding: false,
    label: 'DH-D',
  },
  { id: 'trip_distance', numeric: false, disablePadding: false, label: 'Trip' },
  { id: 'rate', numeric: false, disablePadding: false, label: 'Rate' },
  {
    id: 'trailer_type',
    numeric: false,
    disablePadding: false,
    label: 'Equipment',
  },
  { id: 'full_partial', numeric: false, disablePadding: false, label: 'F/P' },
  { id: 'length', numeric: true, disablePadding: false, label: 'Length' },
  { id: 'weight', numeric: true, disablePadding: false, label: 'Weight' },
  {
    id: 'driver_type',
    numeric: true,
    disablePadding: false,
    label: 'Driver Type',
  },
  { id: 'commodity', numeric: true, disablePadding: false, label: 'Commodity' },
  { id: 'comments', numeric: true, disablePadding: false, label: 'Comments' },
  { id: 'cell', numeric: true, disablePadding: false, label: 'Cell' },
];

const savedSearchHeadCells = [
  { id: 'type', numeric: false, disablePadding: false, label: 'Type' },
  { id: 'origin.name', numeric: false, disablePadding: false, label: 'Origin' },
  {
    id: 'distance_origin',
    numeric: false,
    disablePadding: false,
    label: 'DH-O',
  },
  {
    id: 'destination.name',
    numeric: false,
    disablePadding: false,
    label: 'Destination',
  },
  {
    id: 'distance_destination',
    numeric: false,
    disablePadding: false,
    label: 'DH-D',
  },
  {
    id: 'start_date',
    numeric: false,
    disablePadding: false,
    label: 'Start Date',
  },
  { id: 'end_date', numeric: false, disablePadding: false, label: 'End Date' },
  { id: 'length', numeric: false, disablePadding: false, label: 'Length' },
  { id: 'weight', numeric: false, disablePadding: false, label: 'Weight' },
  {
    id: 'trailer_type',
    numeric: false,
    disablePadding: false,
    label: 'Equipment',
  },
];

function DedicatedLoadTableHead({ classes, order, orderBy, onRequestSort, currentTab, permissions }) {
  let headCells = currentTab === 1 ? savedSearchHeadCells : DedicatedLoadHeadCells;
  const onSortOrderChange = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}>
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={onSortOrderChange(headCell.id)}>
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>{order === 'desc' ? 'sorted descending' : 'sorted ascending'}</span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
        {currentTab === 1 ? <TableCell align="center">Actions</TableCell> : null}
      </TableRow>
    </TableHead>
  );
}

DedicatedLoadTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
};

export default React.memo(DedicatedLoadTableHead);
